import { ArrowDownRight, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/site-data";

export const Hero = () => {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative bg-slate-950 text-white overflow-hidden grain"
    >
      <div
        className="absolute inset-0 opacity-25"
        style={{
          backgroundImage:
            "url('https://images.unsplash.com/photo-1621831337128-35676ca30868?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000')",
          backgroundSize: "cover",
          backgroundPosition: "center right",
        }}
        aria-hidden
      />
      <div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/95 to-slate-950/40" aria-hidden />

      <div className="container-narrow relative pt-32 pb-20 md:pt-44 md:pb-32">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          <div className="md:col-span-9">
            <h1
              data-testid="hero-headline"
              className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl leading-[1.05] tracking-tight animate-fade-up"
            >
              Architecting global impact in{" "}
              <span className="italic text-emerald-300">technology</span>,{" "}
              <span className="italic text-emerald-300">finance</span> &{" "}
              <span className="italic text-emerald-300">sustainability</span>.
            </h1>

            <p
              className="mt-8 max-w-2xl text-slate-300 text-base md:text-lg leading-relaxed animate-fade-up"
              style={{ animationDelay: "220ms" }}
            >
              A Warsaw-headquartered consultancy delivering business and programme
              management for ambitious organisations across Europe and worldwide.
              From municipal water infrastructure to regulated fintech platforms,
              we lead the work that boards stake their reputation on.
            </p>

            <div
              className="mt-10 flex flex-wrap items-center gap-4 animate-fade-up"
              style={{ animationDelay: "340ms" }}
            >
              <button
                data-testid="hero-cta-contact"
                onClick={() => scrollTo("contact")}
                className="bg-emerald-700 hover:bg-emerald-600 transition-colors text-white px-7 py-4 inline-flex items-center gap-3 text-sm font-medium"
              >
                Start a conversation
                <ArrowDownRight size={18} strokeWidth={1.5} />
              </button>
              <button
                data-testid="hero-cta-projects"
                onClick={() => scrollTo("projects")}
                className="border border-white/30 text-white hover:bg-white hover:text-slate-950 transition-colors px-7 py-4 inline-flex items-center gap-3 text-sm font-medium"
              >
                See selected work
              </button>
            </div>
          </div>

          <div className="hidden md:flex col-span-3 flex-col justify-end items-end gap-6">
            <div className="text-right">
              <div className="overline text-slate-400 mb-2">Headquarters</div>
              <div className="font-serif text-2xl leading-tight">
                {COMPANY.hqCity}
              </div>
              <div className="text-slate-400 text-sm flex items-center justify-end gap-1.5 mt-1">
                <MapPin size={12} strokeWidth={1.5} /> {COMPANY.hqCountry}
              </div>
            </div>
            <div className="rule-dark w-24" />
            <div className="text-right">
              <div className="overline text-slate-400 mb-2">Established</div>
              <div className="font-serif text-2xl leading-tight">{COMPANY.founded}</div>
            </div>
          </div>
        </div>

        <div className="mt-20 md:mt-28 border-t border-white/10 pt-8 grid grid-cols-2 md:grid-cols-4 gap-y-6">
          {[
            { k: "Coverage", v: "Europe & Worldwide" },
            { k: "Sectors", v: "IT · Sustainability · Fintech" },
            { k: "Certifications", v: "ISO 27001 · PMI · PRINCE2" },
            { k: "Languages", v: "EN · PL · DE · ES" },
          ].map((b) => (
            <div key={b.k}>
              <div className="overline text-slate-400 mb-2">{b.k}</div>
              <div className="text-sm md:text-base text-white/90">{b.v}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
